export default __webpack_public_path__ + "static/media/handshake.366b011e.svg";